import { cn } from "../../../../lib/cn";
import { ChevronRightIcon } from "../../../../lib/icons";

/** Band disclosure chevron: points right when closed, down when open. */
export const Chevron = ({ open }: { open: boolean }) => (
  <ChevronRightIcon
    aria-hidden
    className={cn(
      "size-5 shrink-0 text-content-secondary transition-transform duration-150 ease-out",
      open ? "rotate-90" : "rotate-0",
    )}
  />
);
